import { RouteLocationNormalized } from 'vue-router';

import { isPublicRoute } from '@/routerAccess';
import { useAccessContextStore } from '@/stores/accessContextStore';
import { useAuthStore } from '@/stores/auth';

/* ------------------------------------------------------------
 * Check if we need to load the access context
 * ------------------------------------------------------------ */
export default async function accessContextGuard(to: RouteLocationNormalized) {
    const authStore = useAuthStore();
    const accessContextStore = useAccessContextStore();

    if (isPublicRoute(to) || !authStore.isAuthenticated) {
        return true;
    }

    await accessContextStore.ensureLoaded();
    return true;
}
